import { useFormContext } from 'react-hook-form';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { ClipboardEventHandler } from 'react';

import { getErrorText } from 'src/utils/form';

export const FormTextField = (props: TextFieldProps & { trim?: boolean }) => {
  const { formState, setValue, trigger } = useFormContext();
  const { trim, ...textFieldProps } = props;
  const error = getErrorText(
    formState.errors,
    props.name || props.InputProps?.name
  );

  const helperText = props.helperText ? (props.helperText as string) : '';
  const handlePaste: ClipboardEventHandler = e => {
    let pastedText = '';

    if (e.clipboardData && e.clipboardData.getData) {
      pastedText = e.clipboardData.getData('text/plain');
    }

    setTimeout(() => {
      if (props.InputProps?.name) {
        setValue(props.InputProps.name, pastedText.trim());
        trigger(props.InputProps.name);
      }
    });
  };

  return (
    <TextField
      onPaste={trim ? handlePaste : undefined}
      error={Boolean(!formState.isValid && error)}
      helperText={
        !formState.isValid && ((error?.message || helperText) as string)
      }
      {...textFieldProps}
    />
  );
};

export default FormTextField;
